// extracted by mini-css-extract-plugin
export default {"root":"LandingPageCarouselRow-module--root--e0db1","noMargin":"LandingPageCarouselRow-module--noMargin--4ac1f"};